export default {
  composition: 'Samenstelling',
  description: 'Omschrijving',
};
